import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
const chips = ['No forms to fill', 'Refunded to your original payment method'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-plum" data-id="element-91" data-mp="1o5zvmfc0uzay">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-92" data-mp="222mz70yhcnpu">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-gold text-gold" data-id="element-93" data-mp="1x5muatdd9r0b">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-94" data-mp="19cegn80181aq" />
          <span className="mt-1 text-[10px] font-semibold uppercase tracking-widest" data-id="element-95" data-mp="14gz7uugvsvl6">
            Guarantee
          </span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-96" data-mp="1j6dcjp9iiou8">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-97" data-mp="qnpy2sp0u824">
          Open everything.{' '}
          <span className="text-gold" data-id="element-98" data-mp="lnbylz1hk6fp">Run a session from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75" data-id="element-99" data-mp="oz9nh1yfddm3">
          Read the volumes, print a Run Sheet, run a table straight from the
          page. If Paid Table Ready doesn&apos;t change how you prepare for your
          sessions, ask for a refund within the guarantee period and you get
          every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-100" data-mp="61700rlizoqe">
          {chips.map(chip => <li key={chip} className="rounded-full border border-plum-line px-4 py-2 text-[13px] text-white/75" data-id="element-101" data-mp="az8mlmi5u66m">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}